const template = require('./addUser.html');
require('./addUser.scss');
var logger = require('../../common/logging.config');

class AddUserController {
	constructor($http, $scope, $translate, $timeout, shellUtil) {
		this.$http = $http;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.shellUtil = shellUtil;

		this.user = {
			displayName: '',
			firstName: '',
			lastName: '',
			externalId: '',
			roles: []
		};

		this.emptyEmail_st = "The email address field is required and cannot be empty. Provide a valid email address.";
		this.invalidEmail_st = "The email address you entered is invalid. Provide a valid email address.";


		this.userRoles = [
			{ name: 'Authenticated visitor', id: 'authenticatedVisitor' },
			{ name: 'Viewer', id: 'viewer' },
			{ name: 'Editor', id: 'editor' },
			{ name: 'Manager', id: 'manager' },
			{ name: 'Administrator', id: 'admin' }
		];

		$translate(this.userRoles.map(role => role.name)).then(translations => {
			this.userRoles.forEach(role => {
				role.name = translations[role.name];
			});
		});

		this.selectedRole = this.userRoles[2];
		// role info needs to be in scope for drop down widget
		$scope.userRoles = this.userRoles;
		$scope.selectedRole = this.selectedRole;
	}

    select(item) {
		logger.info("add user: item selected = " + JSON.stringify(item));
    	this.selectedRole = item;
    	this.$scope.selectedRole = this.selectedRole;
    }

	addUser () {
		// clear out old success/error messages before processing
		this.success = "";
		this.error = "";
		
		if (this.$scope.addUser.$invalid) {
			return;
		}

		this.user.roles = [ this.selectedRole.id ];
		logger.info("add user: posting new user = " + JSON.stringify(this.user));
		this.newUser = this.user.externalId;
		this.$http.post('/api/user-profile/v1/users', this.user).then(() => {
			this.success = "Added {USER}.";
			this.shellUtil.bindAnalytics("e", "WCH Widget Add Users", "WCH Widgets");

		}).catch((res) => {
			// set default failure message
			var errorMessage = "Failed to add user {USER}."; 
			logger.error("add user: failure response = " + JSON.stringify(res.data));

			// see if we have a more descriptive error to present to the user
			if (res.data && res.data.errors && res.data.errors.length > 0) {
				const error =res.data.errors[0];
				
				if (res.status === 409 && error.code && error.code === 106) {
					errorMessage = "User with the email address {USER} already exists. Provide a different email address.";
				}
				else {
					if (error.message) {
						errorMessage = error.message;
					}
					else if (error.description) {
						errorMessage = error.description;
					}
				}
					
			}
			// now display error message
			this.error = errorMessage; 
		});

		//workaround to remove the submitted state on the form.
		this.$timeout(() => {
			this.clear();
		});
	}

	clear () {
		this.$scope.addUser.$setPristine();
		this.$scope.addUser.$setUntouched();
		this.user = {
			displayName: '',
			firstName: '',
			lastName: '',
			externalId: '',
			roles: []
		};
	}
}

module.exports = {
	templateUrl: template,
	controller: [ '$http', '$scope', '$translate', '$timeout', 'shellUtil', AddUserController ]
};


// WEBPACK FOOTER //
// ./app/components/addUser/addUser.component.js